import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import LangSwitcher from "../components/LangSwitcher";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";

export default function Register() {
  const { register } = useAuth();
  const { t, lang } = useI18n();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({
    full_name: "",
    company_name: "",
    email: "",
    password: "",
  });

  const onChange = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register({ ...form, language: lang });
      navigate("/app");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Register failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden p-5">
      <div className="absolute inset-0 grid-bg pointer-events-none" />
      <div className="absolute top-5 left-5">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo-hosys.png" alt="HO-SYS"
               className="w-9 h-9 rounded-lg object-cover" />
          <span className="font-display font-bold">HO-SYS</span>
        </Link>
      </div>
      <div className="absolute top-5 right-5"><LangSwitcher /></div>

      <div className="relative w-full max-w-md card-surface p-8 sm:p-10">
        <h1 className="font-display text-3xl font-bold tracking-tighter mb-2">
          {t("auth.register")}
        </h1>
        <p className="text-sm text-slate-400 mb-7">{t("landing.sub")}</p>

        <form onSubmit={onSubmit} className="space-y-4">
          {[
            { k: "full_name", type: "text", placeholder: "Jordi Martínez" },
            { k: "company_name", type: "text", placeholder: "Hosys Tecnologies SL" },
            { k: "email", type: "email", placeholder: "tu@empresa.com" },
            { k: "password", type: "password", placeholder: "Almenys 6 caràcters" },
          ].map((f) => (
            <div key={f.k}>
              <label className="text-xs uppercase tracking-wider text-slate-400 block mb-2">
                {t(`auth.${f.k}`)}
              </label>
              <Input
                data-testid={`register-${f.k}`}
                type={f.type}
                value={form[f.k]}
                onChange={(e) => onChange(f.k, e.target.value)}
                required
                className="bg-[#05070D] border-white/10 h-11"
                placeholder={f.placeholder}
              />
            </div>
          ))}
          <Button
            type="submit"
            disabled={busy}
            data-testid="register-submit"
            className="w-full h-11 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 shadow-[0_0_20px_rgba(59,130,246,0.3)]"
          >
            {busy ? <Loader2 className="animate-spin mr-2" size={16} /> : null}
            {t("auth.submit_register")}
          </Button>
        </form>

        <div className="mt-6 text-sm text-slate-400 text-center">
          {t("auth.have_account")}{" "}
          <Link to="/login" className="text-blue-400 hover:text-blue-300" data-testid="link-login">
            {t("auth.login")}
          </Link>
        </div>
      </div>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}
